module.exports = __webpack_public_path__ + "static/media/vibermain.178b1b0b.svg";